import React from "react";

import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";
import TrackListItem from "./TrackListItem";

const TracksWithVotesList = ({
  tracks,
  participantVotes,
  clickVote,
  votes,
  showImages,
}) => {
  return (
    <div>
      <Table unstackable inverted style={{ borderRadius: 0 }}>
        <Table.Header>
          <Table.Row />
        </Table.Header>
        <Table.Body>
          {tracks.map((track) => {
            return (
              <TrackListItem
                key={track.uri}
                votes={votes ? votes[track.uri] : 0}
                showImages={showImages}
                hasVoted={
                  Object.keys(participantVotes).indexOf(track.uri) !== -1
                }
                track={track}
                clickVote={clickVote}
              />
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

TracksWithVotesList.propTypes = {
  participantVotes: PropTypes.object.isRequired,
  tracks: PropTypes.array.isRequired,
  clickVote: PropTypes.func.isRequired,
  votes: PropTypes.object,
  compare: PropTypes.func,
  style: PropTypes.object,
  showImages: PropTypes.bool,
};

export default TracksWithVotesList;
